/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: caoran
 * @LastEditTime: 2024-09-07 11:47:50
 */
import React from 'react'

import browser_bar from '../images/browser_bar.png'
import open_in_weixin_mac from '../images/open_in_weixin.jpg'
import open_in_weixin_win from '../images/open_in_weixin_win.png'

import wx_open_browser_bar from '../images/verify-auth/wx_open_browser_bar.png'
import wx_open_web from '../images/verify-auth/wx_open_web.png'

function OpenInWX() {
  const pathname = window.location.pathname
  const copyText = () => {
    const text = 'https://www.5181688.com/verification'
    // 使用 Clipboard API 复制
    navigator.clipboard
      .writeText(text)
      .then(function () {
        alert('复制成功!')
      })
      .catch(function (err) {
        console.error('Could not copy text: ', err)
      })
  }
  if (/\/verification/.test(pathname)) {
    return (
      <div className="open-in-weixin-verify">
        <div className="open-in-weixin-title">
          方法一：复制链接 使用浏览器访问
        </div>
        <div className="web-address-wrapper">
          <div className="web-address">
            https://www.5181688.com/verification
          </div>
          <div className="copy" onClick={copyText}>
            复制链接
          </div>
        </div>
        <div className="open-in-weixin-warning">
          注意：请使用QQ浏览器、360浏览器、搜狗浏览器的【极速模式】或
          其他带有Chrome内核的浏览器。
        </div>
        <img src={wx_open_browser_bar} alt="www.5181688.com/verification" />
        <div className="open-in-weixin-title second-title">
          方法二：点击跳转
        </div>
        <img src={wx_open_web} alt="www.5181688.com/verification" />
      </div>
    )
  }
  return (
    <div className="open-in-weixin">
      <h2>【步骤】：</h2>
      <p>1，在浏览器地址栏输入：5181688.com/</p>
      <img src={browser_bar} alt="5181688.com" />
      <p>2，使用已经加入团队的微信号，扫描登录。</p>
      <p>
        备注：请使用QQ浏览器、360浏览器、搜狗浏览器的【极速模式】或
        其他带有Chrome内核的浏览器打开。
      </p>

      <h2>【快捷打开方式】：</h2>
      <h3>Windows电脑：</h3>
      <img src={open_in_weixin_win} alt="5181688.com" />
      <h3>苹果电脑：</h3>
      <img src={open_in_weixin_mac} alt="5181688.com" />
    </div>
  )
}

export default OpenInWX
